module.exports = __webpack_public_path__ + "img/project10_2.jpg.e3e0e47c.webp";